<template>
  <div>
    <div
      id="dialog-share-mask"
      class="mask"
      :class="{ maskActive: isOpen }"
      data-target="#dialog-share"
      @click="closeSelf"
    />
    <!-- mb版 上滑popup -->
    <transition name="slide-up">
      <div
        v-if="link && isOpen"
        id="dialog-share"
        :class="{ active: isOpen }"
        class="dialog-bottom"
      >
        <div class="share-content">
          <div class="slide-content">
            <a class="btn-delete" @click.prevent="closeSelf">
              <i class="icon-close" />
            </a>
            <div class="icon-wrap">
              <a
                class="btn-share-this"
                data-social="IG"
                href="#"
                @click.prevent="shareToSocial($event, link)"
              >
                <i class="icon-ig" />
              </a>
              <a
                class="btn-share-this"
                data-social="fb"
                href="#"
                @click.prevent="shareToSocial($event, link)"
              >
                <i class="icon-fb" />
              </a>
              <a
                class="btn-share-this"
                data-social="line"
                href="#"
                @click.prevent="shareToSocial($event, link)"
              >
                <i class="icon-line" />
              </a>
              <a
                class="btn-share-this"
                data-social="twitter"
                href="#"
                @click.prevent="shareToSocial($event, link)"
              >
                <i class="icon-twitter" />
              </a>
              <a
                class="btn-share-this"
                data-social="wechat"
                href="#"
                @click.prevent="shareToSocial($event, link)"
              >
                <i class="icon-wechat" />
              </a>
              <a
                class="btn-share-this"
                data-social="whatsapp"
                href="#"
                @click.prevent="shareToSocial($event, link)"
              >
                <i class="icon-whatsapp" />
              </a>
            </div>
            <div class="link-wrap">
              <input id="share-link" readonly :value="link" class="share-link-hidden" type="text" />
              <button
                id="copyLink"
                data-clipboard-target="#share-link"
                @click.prevent="copy(closeSelf)"
              >
                複製連結
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import useShare from '@global/composable/useShare';

const { shareToSocial, copy } = useShare();

const props = defineProps({
  link: {
    type: String,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['closeSelf']);

function closeSelf() {
  emit('closeSelf');
}
</script>
